import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row m-auto dashboard-alerts"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card px-4 py-2 bg-light" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-11 d-flex flex-column justify-content-center" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.alerts.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-1 d-flex flex-column justify-content-center" }, [
                _createElementVNode("i", { class: "fas fa-exclamation-circle text-danger" })
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert, ind) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: ind,
                    class: "text-danger mb-0"
                  }, [
                    _createElementVNode("span", {
                      innerHTML: alert.message
                    }, null, 8, _hoisted_6),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createElementVNode("span", {
                      class: "text-danger alert-link",
                      onClick: ($event: any) => (_ctx.router.push({name:alert.route_name}))
                    }, [
                      _createElementVNode("u", null, _toDisplayString(alert.link_text), 1)
                    ], 8, _hoisted_7)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}